import React from 'react';
import { Button } from '@aidkitorg/component-library';
import { useLocalizedStrings } from '../../../Localization';
import { PaginationProps } from '../types';

/**
 * Pagination component for Support Cases
 */
export const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalCount,
  pageSize,
  hasNextPage,
  hasPreviousPage,
  onPageChange
}) => {
  const L = useLocalizedStrings();
  const startIndex = Math.min((currentPage - 1) * pageSize + 1, totalCount);
  const endIndex = Math.min(currentPage * pageSize, totalCount);

  return (
    <div className="flex items-center justify-between pt-3">
      <div className="text-sm text-gray-700">
        {totalCount === 0 ? (
          <span>{L.admin_panel.support.pagination_no_results}</span>
        ) : (
          <span>
            {L.admin_panel.support.pagination_showing
              .replace('{startIndex}', startIndex.toString())
              .replace('{endIndex}', endIndex.toString())
              .replace('{totalCount}', totalCount.toString())}
          </span>
        )}
      </div>
      <div className="flex items-center gap-2">
        <Button
          size="sm"
          variant="secondary"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={!hasPreviousPage}
          aria-label={L.admin_panel.support.pagination_previous}
        >
          {L.admin_panel.support.pagination_previous}
        </Button>
        <Button
          size="sm"
          variant="secondary"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={!hasNextPage}
          aria-label={L.admin_panel.support.pagination_next}
        >
          {L.admin_panel.support.pagination_next}
        </Button>
      </div>
    </div>
  );
};
